import { Component } from '@verndale/core';
import { createFocusTrap } from 'focus-trap';
import { focusableElements } from '../helpers';
import { KEYS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $modal: this.el,
      $trigger:
        document._$(`[data-trigger-modal="${this.el.id}"]`) ||
        document._$$('.gallery-row__content-button'),
      $closeButton: this.el._$('.modal__close-button'),
      $backdrop: this.el._$('.modal__backdrop'),
      $content: this.el._$('.modal__content'),
      $modalTitle: this.el._$('.modal__title'),
      $modalSummary: this.el._$('.modal__summary'),
      $modalImage: this.el._$('.modal__content-image'),
      $videoContainer: this.el._$('.modal .video__container')
    };

    this.focusableModalElements = this.el._$$(focusableElements);
    this.focusTrap = createFocusTrap(this.el);
    this.videoSrc = this.el.dataset.videoSrc;
    this.videoModalClass = 'modal--video';
  }

  addListeners() {
    this.dom.$backdrop?._on('click', this.handleBackdropClick.bind(this));
    this.dom.$closeButton?._on('click', this.closeModal.bind(this));
    this.dom.$trigger?._on('click', this.openModal.bind(this));
  }

  handleKeydown({ keyCode }) {
    if (keyCode === KEYS.ESC) {
      this.closeModal();
    }
  }

  handleBackdropClick(e) {
    if (e.target === this.dom.$backdrop) {
      this.closeModal();
    }
  }

  openModal(e) {
    const dataset = e.currentTarget.dataset;

    this.el._on('keydown', this.handleKeydown.bind(this));
    this.lastFocusedElement = document.activeElement;
    this.focusableModalElements?.forEach(element =>
      element.setAttribute('tabindex', '1')
    );
    this.el.setAttribute('aria-hidden', 'false');
    this.focusTrap.activate();

    if (this.focusableModalElements?.length) {
      if (this.focusableModalElements[0] !== this.dom.$closeButton)
        this.focusableModalElements[0].focus();
    }

    dataset.videoId
      ? this.dom.$modal.classList.add(this.videoModalClass)
      : this.dom.$modal.classList.remove(this.videoModalClass);

    this.dom.$modalTitle.innerHTML = dataset.title;
    this.dom.$modalSummary.innerHTML = dataset.summary;

    if (dataset.videoId) {
      this.dom.$videoContainer.setAttribute('data-video-id', dataset.videoId);
    } else {
      this.dom.$modalImage.src = ''; // clear previous image
      this.dom.$modalImage.src = dataset.image;
      this.dom.$modalImage.setAttribute('alt', dataset.alt);
    }
  }

  closeModal() {
    this.focusTrap.deactivate();
    this.el.setAttribute('aria-hidden', 'true');

    const iframe = this.el._$('iframe');

    if (iframe.getAttribute('title') !== 'reCAPTCHA') {
      this.el._$('iframe')?.remove();
    }

    if (this.lastFocusedElement) this.lastFocusedElement.focus();
  }
}

export default Module;
